import { useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  useMediaQuery,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import "./filter.scss";
import closeIcon from "../../../../assets/icons/close.svg";

const Filter = ({
  categories,
  teachers,
  setFilter,
  filter,
  setIsMobileFilter,
}: any) => {
  const isMobile = useMediaQuery("(max-width:1000px)");
  const [expandCategory, setExpandCategory] = useState(false);
  const [expandTeachers, setExpandTeachers] = useState(false);
  const progress = [
    { name: "Не начат", id: "NOT_STARTED" },
    { name: "Завершен", id: "COMPLETED" },
    { name: "Выполняется", id: "PERFORMED" },
  ];

  const handleChange = (e: any, type: string) => {
    let temp = [...filter[type]];
    if (filter[type].includes(e.id)) {
      setFilter({ ...filter, [type]: temp.filter((el) => el !== e.id) });
    } else {
      temp.push(e.id);
      setFilter({ ...filter, [type]: temp });
    }
  };

  const resetFilter = () => {
    setFilter({
      category_id: [],
      covered_material: [],
      teacher_id: [],
      search: [],
      order_by: [],
      limit: [12],
      page: [0],
    });
  };

  return (
    <Box className={"filter-wrapper"}>
      {isMobile && (
        <Box className={"filter-title-mobile"}>
          Фильтры
          <img
            src={closeIcon}
            className="closeIcon"
            alt="closeIcon"
            onClick={() => setIsMobileFilter(false)}
          />
        </Box>
      )}
      <Box className={"filter-title"}>Категории</Box>
      <FormGroup className={"filter-item-wrapper"}>
        {categories.map((el: any, index: number) => {
          if (index > 4 && !expandCategory) {
            return null;
          }
          return (
            <FormControlLabel
              key={el.id}
              control={
                <Checkbox
                  checked={filter.category_id.includes(el.id)}
                  onChange={() => handleChange(el, "category_id")}
                />
              }
              label={<span className={"filter-item"}>{el.name}</span>}
            />
          );
        })}
        <Box
          onClick={() => setExpandCategory(!expandCategory)}
          className={"filter-expand"}>
          {!expandCategory ? (
            <span>
              Показать всё <KeyboardArrowDownIcon />
            </span>
          ) : (
            <span>
              Скрыть <KeyboardArrowUpIcon />
            </span>
          )}
        </Box>
      </FormGroup>
      <Box className={"filter-title"}>Успеваемость</Box>
      <FormGroup className={"filter-item-wrapper"}>
        {progress.map((el: any, index: number) => {
          return (
            <FormControlLabel
              key={el.id}
              control={
                <Checkbox
                  checked={filter.covered_material.includes(el.id)}
                  onChange={() => handleChange(el, "covered_material")}
                />
              }
              label={<span className={"filter-item"}>{el.name}</span>}
            />
          );
        })}
      </FormGroup>

      <Box className={"filter-title"}>Преподаватель</Box>
      <FormGroup>
        {teachers?.map((el: any, index: number) => {
          if (index > 6 && !expandTeachers) {
            return null;
          }
          return (
            <FormControlLabel
              key={el.id}
              control={
                <Checkbox
                  checked={filter.teacher_id.includes(el.id)}
                  onChange={() => handleChange(el, "teacher_id")}
                />
              }
              label={<span className={"filter-item"}>{el.fullname}</span>}
            />
          );
        })}
      </FormGroup>
      {teachers.length <= 6 ? null : (
        <Box onClick={() => setExpandTeachers(!expandTeachers)}>
          {!expandTeachers ? (
            <span>
              Показать всё <KeyboardArrowDownIcon />
            </span>
          ) : (
            <span>
              Скрыть <KeyboardArrowUpIcon />
            </span>
          )}
        </Box>
      )}

      {!isMobile && (
        <Box
          onClick={() => {
            resetFilter();
          }}
          className={"filter-reset"}>
          Сбросить
        </Box>
      )}

      {isMobile && (
        <Box
          onClick={() => {
            setIsMobileFilter(false);
          }}
          className={"filter-submit"}>
          Применить
        </Box>
      )}
    </Box>
  );
};

export default Filter;
